import { qualifyUrls } from "routing/Routes";
const forwarderPrefix = "/system/forwarders";
const inputProfilesPrefix = "/system/input_profiles";
const forwarderInputsPath = "/system/inputs/forwarder-inputs";
const ForwarderRoutes = {
  LIST: `${forwarderPrefix}`,
  CREATE: `${forwarderPrefix}/new`,
  configure: (id) => `${forwarderPrefix}/configure/${id}`,
  details: (id) => `${forwarderPrefix}/${id}`,
  FORWARDER_INPUTS: forwarderInputsPath,
  PROFILE: {
    LIST: `${inputProfilesPrefix}`,
    CREATE: `${inputProfilesPrefix}/new`,
    details: (id) => `${inputProfilesPrefix}/${id}`
  }
};
const routes = qualifyUrls(ForwarderRoutes);
export default {
  ...routes,
  unqualified: ForwarderRoutes
};
